export const addTables = (sectionUid, data) => ({
  type: "ADD_TABLES",
  payload: { sectionUid, data },
});

export const updateTables = (sectionUid, data) => ({
  type: "UPDATE_TABLES",
  payload: { sectionUid, data },
});

export const deleteTables = (sectionUid, data) => ({
  type: "DELETE_TABLES",
  payload: { sectionUid, data },
});

export const setSectionName = (sectionUid, data) => ({
  type: "SET_SECTION_NAME",
  payload: { sectionUid, data },
});
export const setSectionTags = (sectionUid, data) => ({
  type: "SET_SECTION_TAGS",
  payload: { sectionUid, data },
});
